<script setup lang="ts">
import {computed} from 'vue'

const props = defineProps<{
  disabled?: boolean
  iconClasses: string
}>()

const allIconClasses = computed(() => ({
  [props.iconClasses]: true,
  'text-new-neutral-600 cursor-not-allowed': props.disabled,
}))
</script>

<template>
  <button :disabled="disabled">
    <slot>
      <i :class="allIconClasses"></i>
    </slot>
  </button>
</template>
